/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Contacts } from './Contacts';
import {
    ContactsFromJSON,
    ContactsFromJSONTyped,
    ContactsToJSON,
    ContactsToJSONTyped,
} from './Contacts';
import type { NdpAddress } from './NdpAddress';
import {
    NdpAddressFromJSON,
    NdpAddressFromJSONTyped,
    NdpAddressToJSON,
    NdpAddressToJSONTyped,
} from './NdpAddress';
import type { ContractPersonRole } from './ContractPersonRole';
import {
    ContractPersonRoleFromJSON,
    ContractPersonRoleFromJSONTyped,
    ContractPersonRoleToJSON,
    ContractPersonRoleToJSONTyped,
} from './ContractPersonRole';
import type { Person } from './Person';
import {
    PersonFromJSON,
    PersonFromJSONTyped,
    PersonToJSON,
    PersonToJSONTyped,
} from './Person';

/**
 * 
 * @export
 * @interface ContractPerson
 */
export interface ContractPerson {
    /**
     * 
     * @type {Person}
     * @memberof ContractPerson
     */
    person: Person;
    /**
     * 
     * @type {ContractPersonRole}
     * @memberof ContractPerson
     */
    role: ContractPersonRole;
    /**
     * 
     * @type {Contacts}
     * @memberof ContractPerson
     */
    contacts?: Contacts;
    /**
     * 
     * @type {NdpAddress}
     * @memberof ContractPerson
     */
    contactAddress?: NdpAddress;
    /**
     * 
     * @type {NdpAddress}
     * @memberof ContractPerson
     */
    permanentAddress?: NdpAddress;
}



/**
 * Check if a given object implements the ContractPerson interface.
 */
export function instanceOfContractPerson(value: object): value is ContractPerson {
    if (!('person' in value) || value['person'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function ContractPersonFromJSON(json: any): ContractPerson {
    return ContractPersonFromJSONTyped(json, false);
}

export function ContractPersonFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractPerson {
    if (json == null) {
        return json;
    }
    return {
        
        'person': PersonFromJSON(json['person']),
        'role': ContractPersonRoleFromJSON(json['role']),
        'contacts': json['contacts'] == null ? undefined : ContactsFromJSON(json['contacts']),
        'contactAddress': json['contactAddress'] == null ? undefined : NdpAddressFromJSON(json['contactAddress']),
        'permanentAddress': json['permanentAddress'] == null ? undefined : NdpAddressFromJSON(json['permanentAddress']),
    };
}

export function ContractPersonToJSON(json: any): ContractPerson {
    return ContractPersonToJSONTyped(json, false);
}

export function ContractPersonToJSONTyped(value?: ContractPerson | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'person': PersonToJSON(value['person']),
        'role': ContractPersonRoleToJSON(value['role']),
        'contacts': ContactsToJSON(value['contacts']),
        'contactAddress': NdpAddressToJSON(value['contactAddress']),
        'permanentAddress': NdpAddressToJSON(value['permanentAddress']),
    };
}

